import styled, { css } from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import {
  azure1,
  azure9,
  grey8,
  azure8,
  grey7,
} from 'approot/shared/styles/colours.style';
import {
  font14,
  PStyled,
  Heading18,
  Heading24,
  HeadingProps,
  LinkStyled,
} from 'approot/shared/styles/typography.style';
import {
  spacing8,
  spacing16,
  spacing24,
  spacing32,
  spacing40,
} from 'approot/shared/styles/spacing.style';
import { LAYOUT_HEADER_HEIGHT } from 'approot/shared/layout/layout.styles';
import { PrimaryLinkButton } from 'approot/shared/styles/buttons/buttons';

export const FlowHeading24 = styled(Heading24)<HeadingProps>`
  margin-bottom: ${({ marginBottom = spacing24 }) => rem(marginBottom)};
`;

export const FlowSubHeading = styled(Heading18).attrs({
  as: 'h2',
  colour: grey8,
  marginBottom: spacing24,
})``;

type FlowComfortContainerProps = {
  top?: number;
};
export const FlowComfortContainer = styled.div<FlowComfortContainerProps>`
  color: ${azure9};
  display: none;

  h3 {
    color: ${azure8};
  }

  ${mediaUp.lg<FlowComfortContainerProps>`
    background-color: ${azure1};
    bottom: 0;
    display: flex;
    position: fixed;
    right: 0;
    top: ${({ top = 0 }) => rem(LAYOUT_HEADER_HEIGHT + top)};
    width: 50%;
  `}
`;

export const FlowSplitWrapper = styled.div`
  display: flex;
`;

export const FlowContent = styled.div`
  flex: 0 0 100%;

  ${mediaUp.lg`
    flex: 0 0 50%;
  `}
`;

type FlowDataRowProps = {
  marginBottom?: boolean;
};

export const FlowDataRow = styled.div<FlowDataRowProps>`
  display: flex;
  ${({ marginBottom }) =>
    marginBottom &&
    `
    margin-bottom: ${rem(spacing8)};
  `}
`;

export const FlowText = styled(PStyled)``;

export const FlowSmallText = styled(PStyled)`
  ${font14}
  a {
    font-size: inherit;
  }
`;

export const FlowLink = styled(LinkStyled)`
  font-size: inherit;
  font-weight: inherit;
`;

const baseFlowBounds = css`
  padding-left: ${rem(spacing16)};
  padding-right: ${rem(spacing16)};
  padding-left: calc(env(safe-area-inset-left) + ${rem(spacing16)});
  padding-right: calc(env(safe-area-inset-right) + ${rem(spacing16)});
`;

export const Flow456Container = styled.div`
  ${baseFlowBounds}

  margin: ${rem(spacing24)} ${rem(spacing8)};

  ${mediaUp.sm`
    // an extra 32px allows for the padding around the safe area
    max-width: ${rem(456 + spacing32)};
    margin: ${rem(spacing40)} auto 0;
  `}
`;

export const Flow712ContainerCenteredContent = styled.div`
  ${baseFlowBounds}
  
  margin: ${rem(spacing24)} ${rem(spacing8)};
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mediaUp.sm`
    // an extra 32px allows for the padding around the safe area
    max-width: ${rem(712 + spacing32)};
    margin: ${rem(spacing40)} auto 0;
  `}
`;

export const FlowImage = styled.div`
  width: ${rem(120)};
  height: ${rem(120)};
  margin-bottom: ${rem(spacing24)};
`;

export const FlowLinkButton = styled(PrimaryLinkButton)`
  color: ${grey7};

  &:hover,
  &:focus {
    color: ${grey8};
  }
`;
